export const paths = {
  FORMS: '/forms/:formId',
  QUIZZES: '/quizzes/:quizId',
};
